import {
    CartItemModel,
    CartModel
} from "@/redux/modules/api/data/cart/@types/cart.model";

export const getCartSkuList = (cart?: CartModel | null) => {
    const isRecommendationsAllowed = ({
        articleConfiguration,
        isAdditionalService,
        giftCardArticle
    }: CartItemModel) =>
        !articleConfiguration && !isAdditionalService && !giftCardArticle;

    return (
        cart?.items.filter(isRecommendationsAllowed).map((item) => item.sku) ??
        []
    );
};
